import React from 'react'
import { Link } from 'gatsby'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import * as Accessa from 'accessa'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { getAsArray } from '../utils/helpers'

const FunFacts = ({ children, ...props }) => {
  const buttons = getAsArray(props, 'callToAction.buttons')
  const facts = getAsArray(props, 'funFacts')

  return (
    <Box bgcolor="background.paper" pt={6}>
      <Container maxWidth="xl">
        <Box mb={buttons.length ? 8 : 4}>
          <Accessa.CallToActions.Leader
            title={get(props, 'callToAction.title')}
            description={get(
              props,
              'callToAction.description.description'
            )}
          >
            {buttons.map((b, i) => (
              <Box
                display="inline-block"
                key={b.relativePath}
                mx={1}
              >
                <Button
                  color={i === 0 ? 'primary' : undefined}
                  component={Link}
                  variant="contained"
                  to={b.relativePath}
                >
                  {b.label}
                </Button>
              </Box>
            ))}
          </Accessa.CallToActions.Leader>
        </Box>
        {facts.length ? (
          <Container
            maxWidth="lg"
            style={{ position: 'relative', zIndex: 20 }}
          >
            <Grid container spacing={1}>
              {facts.map((fact, i) => (
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={12}
                  key={fact + i}
                >
                  <Box
                    bgcolor="background.default"
                    height="100%"
                    style={{
                      borderTop: `2px solid #${fact.colour}`,
                    }}
                  >
                    <Box p={2}>
                      <Typography
                        aria-hidden
                        style={{
                          color: `#${fact.colour}`,
                          fontSize: '3.32rem',
                        }}
                      >
                        {get(fact, 'title')}
                        <span style={{ fontSize: '50%' }}>
                          +
                        </span>
                      </Typography>
                      <Typography
                        component="small"
                        style={{ fontSize: '0.833rem' }}
                      >
                        {get(fact, 'description')}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Container>
        ) : null}
        {children}
      </Container>
    </Box>
  )
}

FunFacts.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.array,
  ]),
}

FunFacts.defaultProps = {
  children: null,
}

export default FunFacts
